<script>
	import { scale, fade } from 'svelte/transition';
	import { currentLevelWin, gotoNextLevel } from '../../stores/current-level';
	import Confetti from '../elements/Confetti.svelte';
	import DarkenOverlay from '../elements/DarkenOverlay.svelte';
	import Icon from '../elements/Icon.svelte';
</script>

<DarkenOverlay />
<Confetti />

<div class="win-card" in:scale out:fade >
	<h1>Well done!</h1>

	<p>You did the thing!</p>

	<button class="large low-focus" on:click={ () => currentLevelWin.set( false ) }>
		<Icon i="arrow-left" />
		Go Back
	</button>

	<button class="large" on:click={ () => gotoNextLevel() }>
		<Icon i="angle-double-right" />
		Next Level
	</button>
</div>

<style>
	.win-card {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate( -50%, -50% );

		background-color: #002240;
		border: 3px solid #FFC300;
		border-radius: 20px;
		color: white;

		text-align: center;
		padding: 20px 50px;
	}

	button {
		margin: 20px;
	}
</style>
